module.exports = __webpack_public_path__ + "static/media/filter-down.47d87ba4.svg";